import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_MIRRORS_LIST = Symbol('admin.mirrors-list');

export const MIRRORS_LIST_JS_MAIN_ROUTE_NAME = Symbol('admin.mirrors-list.main-js');
export const MIRRORS_LIST_NO_JS_MAIN_ROUTE_NAME = Symbol('admin.mirrors-list.main-no-js');

export const MIRRORS_LIST_JS_ROUTE_NAME = Symbol('admin.mirrors-list.list-js');
export const MIRRORS_LIST_NO_JS_ROUTE_NAME = Symbol('admin.mirrors-list.list-no-js');

export const MIRRORS_LIST_QUERY_KEY = 'admin.mirrors-list';
export const MIRRORS_LIST_API_URL = 'admin/mirrors/:mirrorsNamespace';

export const MIRRORS_LIST_DELETE_ITEM_MUTATION_KEY = 'admin.mirrors-list.mutation';
export const MIRRORS_LIST_DELETE_ITEM_API_URL = 'admin/mirrors/:id';

export const MIRRORS_LIST_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.MIRRORS_SHOW),
  CREATE: new Permission(PermissionsList.admin.MIRRORS_CREATE),
  EDIT: new Permission(PermissionsList.admin.MIRRORS_EDIT),
  DELETE: new Permission(PermissionsList.admin.MIRRORS_DELETE),
};
